import * as React from "react";
const SvgVectorIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 9, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#333", fillRule: "evenodd", d: "m8 2.56 5.97 5.97 1.06-1.06L8 .44.97 7.47l1.06 1.06z", clipRule: "evenodd" }));
export default SvgVectorIcon;
